import { Loading } from "element-ui";
import { objectCompare } from "./objectCompare";

export class Pagination {
  current = 1;
  lists;
  size = 10;
  total;
  loading = false;
  preParams = {};
  pageSizes = [10, 50, 100, 500, 1000];
  constructor(arg = {}) {
    this.setAll(arg);
  }

  totalDays = 0;
  totalHours = 0;

  command; //

  params; // 请求参数

  state = false; // request state false 请求结束 true 请求开始

  setLoading = (loading) => {
    this.loading = loading;
    this.setCommand(this.command);
  };

  setCommand = async (command) => {
    let newCommamd = command;
    if (this.loading) {
      newCommamd = async (params) => {
        const loading = Loading.service({ fullscreen: true });
        const res = await command(params);
        loading.close();
        return res;
      };
    }
    this.command = newCommamd;
  };

  setAll({ total, lists }) {
    this.total = total;
    this.lists = lists;
  }

  setParams = (params) => {
    this.params = params;
  };

  setPageNum = (current) => {
    this.current = current;
  };

  search = async (params) => {
    let isChange = false;
    if (params) {
      isChange = objectCompare(params, this.preParams);
      this.preParams = JSON.parse(JSON.stringify(params));
    }
    const currentPage = this.current;
    this.setAll({ lists: [], total: this.total });
    await this.workFlow(
      currentPage && !isChange ? currentPage : 1,
      params,
      this.size
    );
    return;
  };

  pageChange = async (pageNum) => {
    this.workFlow(pageNum, this.params, this.size);
    return;
  };

  reload = async (params) => {
    await this.workFlow(1, params, this.size);
  };

  refreshNowPage = async () => {
    await this.workFlow(this.current, this.params, this.size);
  };

  sizeChange = async (size) => {
    this.workFlow(1, this.params, size);
    return;
  };

  async workFlow(pageNum, params, pageSize) {
    this.state = true;
    this.setPageNum(pageNum);
    this.setParams(params);
    const currentPage = this.current;
    this.size = pageSize;

    const { data={} } = await this.command({
      page: currentPage,
      limit: pageSize,
      ...params,
    });
    
    if (data && data.records) {
      this.setAll({ lists: data.records, total: data.total });
    } else {
      this.setAll({ lists: [], total: 0 });
    }
    if (data && data.totalDays >= 0) {
      this.totalDays = data.totalDays;
    }
    if (data && data.totalHours >= 0) {
      this.totalHours = data.totalHours;
    }

    if (currentPage > 1 && data.total == (currentPage - 1) * pageSize) {
      this.workFlow(currentPage - 1, params, pageSize);
    }

    if (currentPage > 1 && !data.total) {
      this.workFlow(1, params, pageSize);
    }
    this.state = false;
  }
}
